module.exports = __webpack_public_path__ + "static/img/4114_phase_function_Paper_Points.f2ebe1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4114_phase_function_Paper_Points.png
// module id = y3zN
// module chunks = 0